(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["swc-reference-decoder"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  const root = document.getElementById('swc-decoder');
  if (!root) return;
  const data = JSON.parse(document.getElementById('swc-decoder-data').textContent).flat();
  const copy = JSON.parse(document.getElementById('swc-decoder-copy').textContent);
  const input = root.querySelector('#swc-reference');
  const results = root.querySelector('#swc-results');
  const status = root.querySelector('#swc-status');
  const jump = root.querySelector('#swc-matches-jump');
  const esc = value => String(value || '').replace(/[&<>"']/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character]));
  const text = (key, values = {}) => String(copy[key] || '').replace(/\{(\w+)\}/g, (match, name) => values[name] ?? match);
  const norm = value => String(value || '').trim().toUpperCase().replace(/^(?:ROLEX\s+)?(?:REF(?:ERENCE)?\.?\s*)?/, '').replace(/[\s\-–]/g, '');
  const core = value => value.match(/^\d{4,6}/)?.[0];
  const canonical = collection => '/collections/' + encodeURIComponent(collection.handle);
  const familyCollections = new Map();
  data.forEach(watch => {
    if (watch.collection && !/\d{4,6}/.test(watch.collection.handle)) {
      const key = watch.family;
      const options = familyCollections.get(key) || [];
      if (!options.some(item => item.handle === watch.collection.handle)) options.push(watch.collection);
      familyCollections.set(key, options);
    }
  });
  const referenceCount = new Set(data.map(watch => norm(watch.ref))).size;
  root.querySelector('#swc-coverage-count').textContent = text('coverage', {references: referenceCount, listings: data.length});

  function lookup(value) {
    const reference = norm(value);
    if (!/^\d{4,6}[A-Z]{0,8}(?:\d{4})?$/.test(reference)) return {error: text('invalid')};
    let matches = data.filter(watch => norm(watch.ref) === reference);
    if (/^\d{4,6}$/.test(reference)) matches = data.filter(watch => core(norm(watch.ref)) === reference);
    return {reference, matches};
  }

  function collectionFor(reference, matches) {
    const exact = matches.map(watch => watch.collection).find(collection => collection && collection.handle.toUpperCase().split('-').includes(reference));
    if (exact) return {collection: exact, exact: true};
    const common = matches[0].collection;
    if (common && !/\d{4,6}/.test(common.handle) && matches.every(watch => watch.collection?.handle === common.handle)) return {collection: common, exact: false};
    const options = familyCollections.get(matches[0].family) || [];
    const family = matches[0].family.toLowerCase().replace(/\s+/g, '-');
    const collection = options.find(item => item.handle === family) || options[0];
    return collection ? {collection, exact: false} : null;
  }

  function card(watch) {
    const url = esc(watch.url.replace(/^https:\/\/superlativewatchco\.com/, ''));
    const image = watch.image?.url ? '<a class="watch-image" href="' + url + '"><img loading="lazy" width="600" height="600" src="' + esc(watch.image.url) + '" alt="' + esc(watch.image.altText || watch.title) + '"></a>' : '';
    return '<article class="watch-card">' + image + '<div class="watch-info"><div class="eyebrow">Ref. ' + esc(watch.ref) + '</div><h3>' + esc(watch.family) + ' ' + esc(watch.size) + '</h3><p>' + esc([watch.dial, watch.bracelet].filter(Boolean).join(' · ')) + '</p>' + (watch.year ? '<p>' + esc(text('card_year', {year: watch.year})) + '</p>' : '') + '<p>' + esc(text('availability')) + '</p><a class="cta" href="' + url + '">' + esc(text('exact_watch')) + '</a></div></article>';
  }

  function render(value, example = false) {
    const found = lookup(value);
    results.replaceChildren();
    jump.hidden = true;
    input.removeAttribute('aria-invalid');
    if (found.error) {
      input.setAttribute('aria-invalid', 'true');
      status.textContent = found.error;
      return;
    }
    const {reference, matches} = found;
    if (!matches.length) {
      status.textContent = text('no_match', {reference});
      results.innerHTML = '<div class="lookup"><h2>' + esc(text('no_match_title')) + '</h2><p>' + esc(text('no_match_body')) + '</p><a class="cta" href="/pages/buying-desk">' + esc(text('ask_desk')) + '</a></div>';
      return;
    }
    const sorted = [...matches].sort((a, b) => Number(b.availability === 'in_stock') - Number(a.availability === 'in_stock'));
    const first = sorted[0];
    const variants = [...new Set(matches.map(watch => watch.ref))].sort();
    const broad = variants.length > 1;
    const same = key => {
      const values = [...new Set(matches.map(watch => watch[key]).filter(Boolean))];
      return !values.length ? text('not_recorded') : values.length === 1 ? values[0] : text('varies');
    };
    const displayReference = variants.length === 1 && norm(variants[0]) === reference ? variants[0] : reference;
    const countText = text(matches.length === 1 ? 'one_match' : 'many_matches', {count: matches.length, reference: displayReference});
    status.innerHTML = '<strong>' + esc(text(example ? 'example_below' : 'matches_below')) + '</strong><span>' + esc(countText) + '</span>';
    jump.hidden = false;
    const destination = collectionFor(reference, matches);
    const collectionLabel = destination ? text(destination.exact ? 'ref_collection' : 'family_collection', {reference: displayReference, family: destination.collection.title.replace(/ Watches for Sale$/, '')}) : '';
    const badge = destination ? '<a class="ref-badge" href="' + esc(canonical(destination.collection)) + '"><strong>' + esc(displayReference) + '</strong><small>' + esc(collectionLabel) + '</small></a>' : '<a class="ref-badge" href="#swc-matching-watches"><strong>' + esc(displayReference) + '</strong><small>' + esc(text('view_matches')) + '</small></a>';
    const summary = text(reference === '226627' ? 'yacht_summary' : reference === '224270' ? 'explorer_summary' : 'generic_summary', {family: first.family});
    const familyNote = broad ? '<p class="match-context">' + esc(text('family_note', {references: variants.join(', ')})) + '</p>' : '';
    const broadCollectionNote = destination && !destination.exact ? '<p class="hint">' + esc(text('family_collection_note', {family: destination.collection.title})) + '</p>' : '';
    const specs = [['diameter','size'],['material','material'],['movement','calibre'],['bracelet','bracelet']].map(([label, key]) => '<div class="spec"><small>' + esc(text(label)) + '</small>' + esc(same(key)) + '</div>').join('');
    const official = reference === '226627' ? '<p class="hint">' + esc(text('background')) + ' <a href="https://www.rolex.com/watches/yacht-master/m226627-0001" target="_blank" rel="noopener">' + esc(text('official_yacht')) + '</a></p>' : '';
    results.innerHTML = '<div class="result"><div class="result-title"><div><div class="eyebrow">' + esc(text(broad ? 'configuration' : 'watch_behind')) + '</div><h2>Rolex ' + esc(first.family) + '</h2></div>' + badge + '</div><p class="result-copy">' + esc(summary) + '</p>' + familyNote + '<div class="specs">' + specs + '</div><p class="hint">' + esc(text('spec_note')) + '</p>' + official + broadCollectionNote + '<h3 id="swc-matching-watches" class="results-heading" tabindex="-1">' + esc(countText) + '</h3><div class="cards"></div><div class="more-wrap"><button class="load-more" type="button" hidden></button><p class="hint" id="swc-shown" role="status"></p></div>' + (destination ? '<div class="collectionlink"><a class="cta" href="' + esc(canonical(destination.collection)) + '">' + esc(collectionLabel) + '</a></div>' : '') + '</div>';
    const cards = results.querySelector('.cards');
    const more = results.querySelector('.load-more');
    const shown = results.querySelector('#swc-shown');
    let visible = 0;
    function showMore() {
      const next = sorted.slice(visible, visible + 12);
      cards.insertAdjacentHTML('beforeend', next.map(card).join(''));
      visible += next.length;
      more.hidden = visible >= sorted.length;
      more.textContent = text('more', {count: Math.min(12, sorted.length - visible)});
      shown.textContent = sorted.length > 12 ? text('shown', {shown: visible, total: sorted.length}) : '';
    }
    more.addEventListener('click', showMore);
    showMore();
  }

  root.querySelector('form').addEventListener('submit', event => {
    event.preventDefault();
    render(input.value);
  });
  root.querySelectorAll('[data-ref]').forEach(button => button.addEventListener('click', () => {
    input.value = button.dataset.ref;
    render(input.value);
  }));
  jump.querySelector('a').addEventListener('click', () => results.querySelector('#swc-matching-watches')?.focus({preventScroll: true}));
  render('226627', true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["swc-reviews-access"] && !Shopify.designMode) return;
  try {
    (() => {
  const loadedScripts = new Map();
  function activate(region) {
    if (region.dataset.swcReviewState) return;
    const template = region.querySelector('template[data-swc-review-template]');
    if (!template) return;
    region.dataset.swcReviewState = 'loading';
    region.setAttribute('aria-busy', 'true');
    const mount = region.querySelector('[data-swc-review-mount]');
    const placeholder = region.querySelector('[data-swc-review-placeholder]');
    const status = region.querySelector('[data-swc-review-status]');
    const trigger = region.querySelector('[data-swc-review-load]');
    if (status) status.hidden = false;
    if (trigger) trigger.hidden = true;
    mount.append(template.content.cloneNode(true));
    const widget = mount.querySelector('.reputon-google-reviews-widget');
    if (!widget) { region.removeAttribute('aria-busy'); return; }
    const complete = () => {
      const rendered = widget.querySelector('.reputon-reviews-holder');
      if (!rendered || !rendered.textContent.trim()) return false;
      region.dataset.swcReviewState = 'ready';
      region.removeAttribute('aria-busy');
      placeholder.hidden = true;
      const rating = widget.querySelector('.reputon-reviews-head .reputon-rating-stars');
      const value = rating?.textContent.trim().match(/^[0-5](?:[.,]\d)?$/)?.[0];
      if (value) document.querySelectorAll('[data-swc-review-rating]').forEach(node => { node.textContent = value; });
      return true;
    };
    const observer = new MutationObserver(() => { if (complete()) observer.disconnect(); });
    observer.observe(widget, { childList: true, subtree: true, characterData: true });
    const fail = () => {
      if (complete()) return;
      observer.disconnect();
      region.dataset.swcReviewState = 'unavailable';
      region.removeAttribute('aria-busy');
      if (status) status.hidden = true;
    };
    const type = widget.dataset.type;
    const existing = Array.from(document.scripts).find(script => script.src.includes('/reputon-google-' + type + '-widget.js'));
    if (existing) {
      const src = existing.src;
      if (!loadedScripts.has(src)) {
        loadedScripts.set(src, new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = src;
          script.async = true;
          script.dataset.swcReviewActivation = '';
          script.onload = resolve;
          script.onerror = reject;
          document.head.append(script);
        }));
      }
      loadedScripts.get(src).catch(fail);
    } else {
      fail();
    }
    setTimeout(() => { if (region.dataset.swcReviewState !== 'ready') fail(); }, 20000);
  }
  function setup() {
    const regions = Array.from(document.querySelectorAll('[data-swc-review-region]'));
    const shortcut = document.querySelector('[data-swc-reviews-shortcut]');
    if (!regions.length || !shortcut) return;
    const first = regions[0];
    first.id = 'swc-google-reviews';
    shortcut.href = '#swc-google-reviews';
    shortcut.hidden = false;
    shortcut.addEventListener('click', event => {
      event.preventDefault();
      activate(first);
      first.focus({ preventScroll: true });
      first.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });
    regions.forEach(region => {
      region.querySelector('[data-swc-review-load]')?.addEventListener('click', () => activate(region));
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); activate(region); }
        }, { rootMargin: '1000px 0px' });
        observer.observe(region);
      } else activate(region);
    });
    if (location.hash === '#swc-google-reviews') activate(first);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["swc-rolex-family-authority-hub"] && !Shopify.designMode) return;
  try {
    (() => {
    const filterPrefix = '#swc-daytona-filter-';
    const labels = {
      all: 'Current Cosmograph Daytona Inventory',
      steel: 'Steel Daytona Inventory',
      rolesor: 'Two-Tone Daytona Inventory',
      oysterflex: 'Oysterflex Daytona Inventory',
      'full-metal': 'Full-Metal Gold Daytona Inventory',
      platinum: 'Platinum Daytona Inventory',
      collector: 'Collector Daytona Inventory'
    };

    const applyFilter = (key, shouldScroll) => {
      const grid = document.getElementById('CollectionProductGrid');
      const container = grid?.querySelector('[data-product-container]');
      if (!grid || !container || !labels[key]) return;
      const cards = Array.from(container.querySelectorAll('[data-swc-daytona-groups]'));
      if (!cards.length) return;
      let visibleCount = 0;
      cards.forEach((card) => {
        const groups = (card.dataset.swcDaytonaGroups || '').split(/\s+/).filter(Boolean);
        const visible = key === 'all' || groups.includes(key);
        card.hidden = !visible;
        card.setAttribute('aria-hidden', visible ? 'false' : 'true');
        if (visible) visibleCount += 1;
      });
      document.querySelectorAll('[data-swc-daytona-filter]').forEach((button) => {
        button.setAttribute('aria-pressed', button.dataset.swcDaytonaFilter === key ? 'true' : 'false');
      });
      const title = grid.querySelector('[data-swc-daytona-inventory-title]');
      const countLine = grid.querySelector('[data-swc-daytona-count-line]');
      if (title) title.textContent = labels[key];
      if (countLine) countLine.textContent = visibleCount === 1 ? '1 watch is currently shown in this view.' : `${visibleCount} watches are currently shown in this view.`;
      if (shouldScroll) {
        grid.scrollIntoView({ behavior: 'auto', block: 'start' });
        title?.focus({ preventScroll: true });
      }
    };

    const filterFromHash = () => {
      if (!window.location.hash.startsWith(filterPrefix)) return 'all';
      return window.location.hash.slice(filterPrefix.length);
    };

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('[data-swc-daytona-filter]');
      if (!button) return;
      const key = button.dataset.swcDaytonaFilter;
      if (!labels[key]) return;
      window.history.pushState(null, '', `${filterPrefix}${key}`);
      applyFilter(key, true);
    });

    const initialize = () => applyFilter(filterFromHash(), false);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
    else initialize();
    window.addEventListener('hashchange', initialize);
    window.addEventListener('popstate', initialize);
  })();
  } catch(e) { console.error(e); }
})();

})();
